import { useState } from "react"
import { string, func, object } from "prop-types"
import { validator } from "./validator"
import { Box, StackView } from "@planningcenter/tapestry-react"

const NewScholarship = props => {
  const {
    scholarship,
    currencySymbol,
    onSave,
    onCancel,
    fieldWrapper,
    submitButtonLabel = "Save"
  } = props

  const totalAmountDollars = scholarship.total_amount_cents / 100

  const [name, setName] = useState(scholarship.name || "")
  const [totalAmount, setTotalAmount] = useState(totalAmountDollars || 0)
  const [formValidation, setFormValidation] = useState({
    name: null,
    totalAmount: null
  })

  const validateForm = () => {
    const validation = validator({ name, totalAmount })
    setFormValidation(validation)
    return validation
  }

  const handleSubmit = () => {
    const validation = validateForm()

    // Return if form is not valid
    if (validation.totalAmount || validation.name) {
      return
    }

    // If valid, call and return handleSave method
    return onSave({
      name,
      total_amount: totalAmount,
      ...(scholarship.id !== "new" && { id: scholarship.id })
    })
  }

  return (
    <>
      <Box
        as={fieldWrapper}
        key={scholarship.id}
        paddingHorizontal={fieldWrapper === "td" ? 2 : null}
        paddingVertical={fieldWrapper === "td" ? 1 : null}
      >
        <Box width="240px">
          <label htmlFor="name" className="screen-reader-text">
            Scholarship Name
          </label>
          <input
            autoFocus
            className={`${formValidation.name && "error-input"}`}
            type="text"
            name="name"
            placeholder="Scholarship name"
            value={name}
            onChange={e => setName(e.target.value)}
          />
          {formValidation.name && (
            <div className="c-error font-size-5 pt-4p">{formValidation.name}</div>
          )}
        </Box>
      </Box>
      <Box as={fieldWrapper} paddingHorizontal={2} paddingVertical={1}>
        <Box width="120px">
          <label htmlFor="totalAmount" className="screen-reader-text">
            Amount
          </label>
          <div className="prepended-label">
            <div className="label t-1p">{currencySymbol}</div>
            <input
              className={formValidation.totalAmount && "error-input"}
              type="text"
              name="totalAmount"
              placeholder="Amount"
              value={totalAmount}
              onChange={e => setTotalAmount(e.target.value)}
            />
          </div>
          {formValidation.totalAmount && (
            <div className="c-error font-size-5 pt-4p">{formValidation.totalAmount}</div>
          )}
        </Box>
      </Box>
      {fieldWrapper === "td" && <td />}

      <Box
        as={fieldWrapper}
        paddingHorizontal={fieldWrapper === "td" ? 2 : null}
        paddingVertical={fieldWrapper === "td" ? 1 : null}
      >
        <StackView axis="horizontal" spacing={1}>
          {onCancel && (
            <button className="btn-outline xs" onClick={() => onCancel()}>
              Cancel
            </button>
          )}
          <button
            className={`${fieldWrapper === "td" && "xs"} btn-solid interaction`}
            type="submit"
            onClick={handleSubmit}
          >
            {submitButtonLabel}
          </button>
        </StackView>
      </Box>
    </>
  )
}

NewScholarship.propTypes = {
  scholarship: object.isRequired,
  currencySymbol: string.isRequired,
  onSave: func.isRequired,
  onCancel: func.isRequired,
  fieldWrapper: string,
  submitButtonLabel: string
}

export default NewScholarship
